export default function FontAwesomeIcon({ name, color = 'var(--primary)' }) {
	return <i className={name} style={{ color: `${color}`, width: '16px', height: '14px' }} />;
}
